import { HttpClient } from '@angular/common/http';
import { ErrorHandler, Injectable, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  TranslateCompiler,
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as Sentry from '@sentry/browser';
import { NZ_DATE_LOCALE } from 'ng-zorro-antd/i18n';
import {
  MESSAGE_FORMAT_CONFIG,
  TranslateMessageFormatCompiler,
} from 'ngx-translate-messageformat-compiler';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { LinkCustomDirective } from './core/directives/link-custom.directive';
import { BeddyDirective } from './core/easter-eggs/beddy.directive';
import { RootStoreModule } from './root-store/root-store.module';
import { UiModule } from './ui/ui.module';

import itDateFns from 'date-fns/locale/it';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { JwtModule } from '@auth0/angular-jwt';
import { NgxExtendedPdfViewerService } from 'ngx-extended-pdf-viewer';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { MOBILE_LIFECYCLE_INIT_PROVIDER } from './core/providers/initializers/mobile-lifecycle.initializer';
import { TOKEN_SERVICE_PROVIDER } from './core/providers/token-service.provider';
import { GOOGLE_AUTH_WARNING_STORAGE_PROVIDER } from './core/providers/google-auth-warning-storage.provider';
import { TIME_PROVIDER_PROVIDER } from './core/providers/time-provider.provider';
import { CLOUD_MESSAGING_PROVIDER } from './core/providers/cloud-messaging.provider';
import { CLOUD_MESSAGING_INIT_PROVIDER } from './core/providers/initializers/cloud-messaging.initializer';
import { SPEECH_ADAPTER_PROVIDER } from './core/providers/speech-recognition-adapter.provider';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// Sentry.init({
//   ...environment.sentry,
// });

export function tokenGetter() {
  return localStorage.getItem('access_token');
}

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() {}
  handleError(error) {
    if (
      error &&
      error.message &&
      (error.message.match('ExpressionChangedAfterItHasBeenCheckedError') ||
        error.message.match('_keydownEventSubscriptions') ||
        error.message.match('overlays[i]') ||
        error.message.match('Attempt to use a destroyed view: detectChanges'))
    ) {
      return null;
    }
    const eventId = Sentry.captureException(error.originalError || error);
    Sentry.showReportDialog({ eventId });
    console.error(error);
  }
}

@NgModule({
  declarations: [AppComponent, BeddyDirective, LinkCustomDirective],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RootStoreModule,
    CoreModule,
    UiModule,
    NzAlertModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
      },
    }),

    TranslateModule.forRoot({
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler,
      },
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  /// providers: [{ provide: ErrorHandler, useClass: SentryErrorHandler }],

  providers: [
    TOKEN_SERVICE_PROVIDER,
    GOOGLE_AUTH_WARNING_STORAGE_PROVIDER,
    TIME_PROVIDER_PROVIDER,
    MOBILE_LIFECYCLE_INIT_PROVIDER,
    CLOUD_MESSAGING_PROVIDER,
    CLOUD_MESSAGING_INIT_PROVIDER,
    SPEECH_ADAPTER_PROVIDER,

    {
      provide: MESSAGE_FORMAT_CONFIG,
      useValue: {
        biDiSupport: false,
      },
    },
    { provide: NZ_DATE_LOCALE, useValue: itDateFns },
    provideEnvironmentNgxMask(),
    NgxExtendedPdfViewerService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
